export const productTypes = {
  CHARGE: 'charge',
  SUBSCRIPTION: 'subscription',
};
